/* SOFS Backpack Viewer — colorways, vista frontal/espalda, hotspots y story steps */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.bpvReady === '1') return;
    root.dataset.bpvReady = '1';

    var stageCol  = root.querySelector('[data-bpv-stage-col]');
    var tabs      = Array.prototype.slice.call(root.querySelectorAll('[data-bpv-tab]'));
    var swatches  = Array.prototype.slice.call(root.querySelectorAll('[data-bpv-swatch]'));
    var stages    = Array.prototype.slice.call(root.querySelectorAll('[data-bpv-stage]'));
    var steps     = Array.prototype.slice.call(root.querySelectorAll('[data-bpv-step]'));
    var infos     = Array.prototype.slice.call(root.querySelectorAll('[data-bpv-info]'));
    var forms     = Array.prototype.slice.call(root.querySelectorAll('[data-bpv-form]'));

    var autoplay  = root.dataset.bpvAutoplay === 'true';
    var interval  = parseInt(root.dataset.bpvInterval, 10) || 4000;
    var introOn   = root.dataset.bpvIntro !== 'false';
    var introMs   = parseInt(root.dataset.bpvIntroSpeed, 10) || 45;
    /* Modo scroll: el morral no se arrastra, gira apenas mientras se baja */
    var scrollSpin = parseInt(root.dataset.bpvScroll, 10) || 0;
    /* Modo giro continuo: da vueltas solo, siempre, mientras se ve en pantalla.
       El número son los milisegundos que dura cada cuadro. */
    var girarSiempre = parseInt(root.dataset.bpvSpin, 10) || 0;
    /* Los puntos siguen a su pieza mientras el morral gira.
       El morral visto desde arriba es un óvalo: ancho de frente y más angosto
       de costado. Con una sola medida los puntos se salen del morral en los
       ángulos intermedios, así que van las dos. */
    var seguirPuntos = root.dataset.bpvTrack !== 'false';
    var medioAncho = parseFloat(root.dataset.bpvSpan) || 24;
    var medioFondo = parseFloat(root.dataset.bpvDepth) || 14;
    var margenVisible = parseFloat(root.dataset.bpvArc);
    if (isNaN(margenVisible)) margenVisible = 0.12;
    var invert    = root.dataset.bpvInvert === 'true';
    var turns     = parseFloat(root.dataset.bpvTurns) || 1;
    var isPhone   = window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
    /* En el home la lista de detalles es un acordeón: arranca cerrada y el
       detalle abierto se cierra al volver a tocarlo. En el PDP siempre hay uno
       visible, así que allá se mantiene el primero. */
    var isHome    = root.classList.contains('bpv--home');

    var colorway = 0;
    var view = 'front';
    var frameAt = [];   // frame actual de cada colorway en modo 360
    stages.forEach(function (st, i) { frameAt[i] = 0; });

    function frameCount(i) { return parseInt(stages[i] && stages[i].dataset.bpvFrames, 10) || 0; }
    function is360() { return frameCount(colorway) >= 2; }
    function modelOf(i) { return stages[i] ? stages[i].querySelector('[data-bpv-model]') : null; }
    function is3D() { return !!modelOf(colorway); }

    /* El visor 3D pesa: se descarga una sola vez y sólo si hay modelos */
    function loadModelViewer() {
      if (window.__bpvModelViewer) return window.__bpvModelViewer;
      if (!root.querySelector('[data-bpv-model]')) return null;
      window.__bpvModelViewer = new Promise(function (resolve) {
        if (window.customElements && customElements.get('model-viewer')) return resolve();
        var s = document.createElement('script');
        s.type = 'module';
        s.src = 'https://ajax.googleapis.com/ajax/libs/model-viewer/3.5.0/model-viewer.min.js';
        s.onload = function () { resolve(); };
        s.onerror = function () { resolve(); };
        document.head.appendChild(s);
      });
      return window.__bpvModelViewer;
    }

    /* Gira el modelo a un ángulo dado, ej "90deg 78deg 105%" */
    function orbitTo(orbit) {
      var mv = modelOf(colorway);
      if (!mv || !orbit) return;
      mv.cameraOrbit = orbit;
    }

    /* Los frames se descargan al primer contacto, no en la carga del home.
       En celular se pide la versión angosta: la misma vuelta pesa la mitad. */
    function srcOf(img) {
      var m = isPhone && img.getAttribute('data-bpv-srcm');
      return m || img.getAttribute('data-bpv-src') || img.getAttribute('data-bpv-srcm');
    }
    function hydrateFrames(i, done) {
      var st = stages[i];
      if (!st) return;
      if (st.dataset.bpvHydrated === '1') { if (done) done(); return; }
      st.dataset.bpvHydrated = '1';

      var pend = 1, called = false;   // el 1 es la guarda hasta terminar el recorrido
      function tickDone() {
        pend--;
        if (pend > 0 || called) return;
        called = true;
        st.classList.remove('is-loading');
        if (done) done();
      }

      st.classList.add('is-loading');
      st.querySelectorAll('img[data-bpv-src], img[data-bpv-srcm]').forEach(function (img) {
        var url = srcOf(img);
        if (!url || img.getAttribute('src') === url) return;
        pend++;
        img.addEventListener('load', function () {
          // Decodificar por adelantado: si no, el primer paso del giro que
          // muestra este cuadro se come la decodificación y parpadea.
          if (img.decode) img.decode().catch(function () {}).then(tickDone, tickDone);
          else tickDone();
        }, { once: true });
        img.addEventListener('error', tickDone, { once: true });
        img.src = url;
        img.removeAttribute('data-bpv-src');
        img.removeAttribute('data-bpv-srcm');
      });
      tickDone();
    }
    var stepKeys = steps.map(function (s) { return s.dataset.bpvStep; });
    var stepViews = {};
    steps.forEach(function (s) { stepViews[s.dataset.bpvStep] = s.dataset.bpvView || 'front'; });
    /* Ni el home ni la ficha de producto arrancan con un detalle abierto: en la
       ficha sale el aviso de «selecciona un punto» hasta que el visitante toque uno. */
    var isPdp     = root.classList.contains('bpv--pdp');
    /* La ficha puede arrancar con el primer detalle abierto (ajuste «Abrir el
       primer detalle al entrar», que el liquid marca con bpv--abre-primero). */
    var abrePrimero = root.classList.contains('bpv--abre-primero');
    var activeKey = (isHome || (isPdp && !abrePrimero)) ? null : (stepKeys[0] || null);
    var timer = null;

    /* ---- render ---- */

    function paintStep(key) {
      root.classList.toggle('bpv--sin-detalle', !key);
      requestAnimationFrame(medirNav);
      steps.forEach(function (s) {
        s.classList.toggle('is-active', s.dataset.bpvStep === key);
      });
      root.querySelectorAll('[data-bpv-hotspot]').forEach(function (h) {
        h.classList.toggle('is-active', h.dataset.bpvHotspot === key);
      });
    }

    function paintView() {
      stages.forEach(function (stage, i) {
        var target;
        if (stage.querySelector('[data-bpv-model]')) target = 'model';
        else if (frameCount(i) >= 2) target = 'f' + frameAt[i];
        else target = view;
        /* El cuadro que se va queda marcado y sigue opaco debajo del nuevo:
           si el que entra todavía no cargó, no se abre un hueco al fondo. */
        var mostrado = stage.dataset.bpvShown || '';
        if (mostrado !== target) stage.dataset.bpvPrevShot = mostrado;
        stage.dataset.bpvShown = target;
        var previo = stage.dataset.bpvPrevShot || '';
        stage.querySelectorAll('[data-bpv-shot]').forEach(function (shot) {
          var on = shot.dataset.bpvShot === target;
          shot.classList.toggle('is-active', on);
          shot.classList.toggle('is-prev', !on && shot.dataset.bpvShot === previo);
        });
      });
      moverPuntos();
      tabs.forEach(function (t) {
        var on;
        if (is3D()) on = false;
        else if (is360()) on = t.dataset.bpvTab === 'front'
          ? frameAt[colorway] === 0
          : frameAt[colorway] === Math.round(frameCount(colorway) / 2);
        else on = t.dataset.bpvTab === view;
        t.setAttribute('aria-selected', String(on));
      });
    }

    /* Cuando el morral se queda quieto, el cuadro a la vista se reemplaza por
       la versión nítida. Girando van los livianos: son 36 por color. */
    var sharpTimer = null;

    function sharpenSoon() {
      if (sharpTimer) clearTimeout(sharpTimer);
      sharpTimer = setTimeout(function () {
        sharpTimer = null;
        var st = stages[colorway];
        if (!st) return;
        var shot = st.querySelector('.bpv__shot--seq.is-active');
        var img = shot && shot.querySelector('img');
        if (!img || img.dataset.bpvSharp === '1') return;
        var hi = (isPhone && img.getAttribute('data-bpv-him')) || img.getAttribute('data-bpv-hi');
        if (!hi || img.getAttribute('src') === hi) { if (img) img.dataset.bpvSharp = '1'; return; }
        var pre = new Image();
        pre.onload = function () {
          // Recién se cambia cuando la nítida está decodificada, para que el
          // reemplazo no deje el cuadro en blanco ni un instante.
          function swap() { img.src = hi; img.dataset.bpvSharp = '1'; }
          if (pre.decode) pre.decode().then(swap, swap); else swap();
        };
        pre.src = hi;
      }, 260);
    }

    /* Mientras el morral gira los puntos se apagan y vuelven al detenerse:
       verlos viajar sobre la foto ensucia el movimiento. */
    var quietoTimer = null;

    function marcarGirando() {
      root.classList.add('bpv--girando');
      if (quietoTimer) clearTimeout(quietoTimer);
      quietoTimer = setTimeout(function () {
        quietoTimer = null;
        root.classList.remove('bpv--girando');
      }, 220);
    }

    /* Mueve la rotación a un frame concreto (da la vuelta en los extremos) */
    function setFrame(i, n) {
      var total = frameCount(colorway);
      if (total < 2) return;
      var antes = frameAt[colorway];
      frameAt[colorway] = ((n % total) + total) % total;
      if (frameAt[colorway] !== antes) marcarGirando();
      paintView();
      sharpenSoon();
    }

    /* ---- los puntos siguen al morral ----
       Se trata cada punto como pegado a la superficie de un cilindro. Con
       dónde se lo colocó y en qué cuadro se lo colocó alcanza para saber en
       qué ángulo del morral vive: de ahí sale dónde cae en cualquier otro
       cuadro y cuándo queda del lado que no se ve. */
    function moverPuntos() {
      if (!seguirPuntos) return;
      var st = stages[colorway];
      if (!st) return;
      var total = frameCount(colorway);
      if (total < 2) return;
      var vuelta = (Math.PI * 2) / total;
      var actual = frameAt[colorway];

      var escala = Math.sqrt(medioAncho * medioAncho + medioFondo * medioFondo) || 1;

      // Dónde cae el punto y qué tan de cara queda, con el morral girado en giro
      function proyectar(t, giro) {
        return {
          x: medioAncho * Math.cos(t) * Math.cos(giro) - medioFondo * Math.sin(t) * Math.sin(giro),
          cara: medioAncho * Math.cos(t) * Math.sin(giro) + medioFondo * Math.sin(t) * Math.cos(giro)
        };
      }

      st.querySelectorAll('.bpv__hotspot--track').forEach(function (hs) {
        var hx = parseFloat(hs.dataset.bpvHx);
        if (isNaN(hx)) return;
        var ancla = parseFloat(hs.dataset.bpvAnchor) || 0;
        var giroAncla = ancla * vuelta;
        var dx = hx - 50;

        /* Se despeja en qué punto del óvalo está, a partir de dónde se lo
           colocó. Da dos soluciones (una de cara y otra por detrás): se toma
           la que estaba a la vista en el cuadro donde se lo puso. */
        var t = parseFloat(hs.dataset.bpvT);
        if (isNaN(t) || hs.dataset.bpvTFor !== String(hx) + ':' + String(ancla)) {
          var R = Math.sqrt(
            Math.pow(medioAncho * Math.cos(giroAncla), 2) +
            Math.pow(medioFondo * Math.sin(giroAncla), 2)
          ) || 1;
          var fase = Math.atan2(medioFondo * Math.sin(giroAncla), medioAncho * Math.cos(giroAncla));
          var razon = Math.max(-1, Math.min(1, dx / R));
          var t1 = Math.acos(razon) - fase;
          var t2 = -Math.acos(razon) - fase;
          t = proyectar(t1, giroAncla).cara >= proyectar(t2, giroAncla).cara ? t1 : t2;
          hs.dataset.bpvT = t;
          hs.dataset.bpvTFor = String(hx) + ':' + String(ancla);
        }

        /* Cuánto acompaña el giro: 100% para lo que está en la superficie,
           bajo para lo que vive arriba y al centro (el asa), que casi no se
           corre al girar y se ve desde cualquier ángulo. */
        var viaje = parseFloat(hs.dataset.bpvTravel);
        if (isNaN(viaje)) viaje = 100;
        viaje = Math.max(0, Math.min(100, viaje)) / 100;

        var p = proyectar(t, actual * vuelta);
        hs.style.left = (50 + p.x * viaje) + '%';
        hs.classList.toggle('is-hidden', viaje > 0.15 && p.cara / escala < margenVisible);
      });
    }

    function paintColorway() {
      swatches.forEach(function (sw, i) {
        sw.setAttribute('aria-pressed', String(i === colorway));
      });
      var bg = stages[colorway] && stages[colorway].dataset.bpvBg;
      if (bg && stageCol) stageCol.style.setProperty('--bpv-stage-bg', bg);
      stages.forEach(function (st, i) {
        st.classList.toggle('is-active', i === colorway);
      });
      infos.forEach(function (el, i) {
        el.classList.toggle('is-active', i === colorway);
      });
      forms.forEach(function (el, i) {
        el.classList.toggle('is-active', i === colorway);
      });
      root.querySelectorAll('.bpv__step-photos').forEach(function (wrap) {
        wrap.querySelectorAll('[data-bpv-photo]').forEach(function (ph, i) {
          ph.classList.toggle('is-active', i === colorway);
        });
      });
    }

    /* Activa un paso. Si el paso pertenece a la otra vista, cambia la vista. */
    /* «quieto» = cambiar de detalle SIN mover el morral: el visitante lo dejó en
       un ángulo y ni la lista ni los puntos sobre la foto deben devolverlo al
       frente: solo cambian el detalle que se está mostrando. */
    function goToStep(key, quieto) {
      if (!key) return;
      activeKey = key;
      if (is3D()) {
        var el = null;
        steps.forEach(function (s) { if (s.dataset.bpvStep === key) el = s; });
        if (!quieto && el && el.dataset.bpvOrbit) orbitTo(el.dataset.bpvOrbit);
        stopAuto();
        paintStep(key);
        return;
      }
      if (quieto) { stopAuto(); paintStep(key); return; }
      if (is360()) {
        hydrateFrames(colorway);
        var hs = stages[colorway].querySelector('[data-bpv-hotspot="' + key + '"]');
        var shot = hs && hs.closest('[data-bpv-shot]');
        if (hs && hs.dataset.bpvAnchor !== undefined) setFrame(colorway, parseInt(hs.dataset.bpvAnchor, 10) || 0);
        else if (shot) setFrame(colorway, parseInt(shot.dataset.bpvShot.slice(1), 10));
        else paintView();
      } else {
        var wanted = stepViews[key] || 'front';
        if (wanted !== view) { view = wanted; paintView(); }
      }
      paintStep(key);
    }

    function setView(next) {
      if (is3D()) {
        orbitTo(next === 'back' ? '180deg 78deg 105%' : '0deg 78deg 105%');
        tabs.forEach(function (t) { t.setAttribute('aria-selected', String(t.dataset.bpvTab === next)); });
        return;
      }
      if (is360()) {
        hydrateFrames(colorway);
        setFrame(colorway, next === 'back' ? Math.round(frameCount(colorway) / 2) : 0);
        return;
      }
      if (next === view) return;
      view = next;
      paintView();
      // Salta al primer paso que corresponda a esta vista
      /* Solo salta si ya se estaba viendo un detalle: si no hay ninguno, girar el
         morral no debe elegir uno — el aviso sigue en su sitio. */
      var first = stepKeys.find(function (k) { return stepViews[k] === view; });
      if (first && activeKey) { activeKey = first; paintStep(first); }
    }

    function setColorway(i) {
      if (i === colorway || i < 0 || i >= stages.length) return;
      colorway = i;
      if (frameCount(i) >= 2) hydrateFrames(i);
      paintColorway();
      paintView();
      paintStep(activeKey);
    }

    /* ---- flechas de la ficha (computador) ----
       Pasan al detalle anterior / siguiente sin girar el morral, igual que la
       lista. Se paran sobre la foto: su alto cambia con el texto de cada detalle,
       por eso se mide cada vez que cambia el detalle y al redimensionar. */
    var navEl = root.querySelector('.bpv__nav');
    function medirNav() {
      if (!navEl) return;
      var ph = root.querySelector('.bpv__step.is-active .bpv__step-photos');
      if (ph) navEl.style.setProperty('--bpv-nav-h', ph.offsetHeight + 'px');
    }
    if (navEl) {
      navEl.addEventListener('click', function (e) {
        var b = e.target.closest('[data-bpv-nav]');
        if (!b || !stepKeys.length) return;
        e.preventDefault();
        e.stopPropagation();
        stopAuto();
        var dir = parseInt(b.dataset.bpvNav, 10) || 1;
        var idx = stepKeys.indexOf(activeKey);
        var next = idx < 0 ? (dir > 0 ? 0 : stepKeys.length - 1)
                           : (idx + dir + stepKeys.length) % stepKeys.length;
        goToStep(stepKeys[next], true);
      });
      window.addEventListener('resize', medirNav, { passive: true });
      window.addEventListener('load', medirNav);
    }

    /* ---- autoplay ---- */

    function tick() {
      var idx = stepKeys.indexOf(activeKey);
      goToStep(stepKeys[(idx + 1) % stepKeys.length]);
    }
    function startAuto() {
      if (!autoplay || stepKeys.length < 2 || timer) return;
      if (is3D()) return;   // el modelo sólo se mueve si lo mueve el visitante
      timer = setInterval(tick, interval);
    }
    function stopAuto() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    /* ---- eventos ---- */

    tabs.forEach(function (t) {
      t.addEventListener('click', function () { stopAuto(); setView(t.dataset.bpvTab); });
    });

    swatches.forEach(function (sw, i) {
      sw.addEventListener('click', function () { stopAuto(); setColorway(i); });
    });

    steps.forEach(function (s) {
      s.addEventListener('click', function () {
        stopAuto();
        if (isHome && s.dataset.bpvStep === activeKey) { activeKey = null; paintStep(null); return; }
        goToStep(s.dataset.bpvStep, true);
      });
    });

    root.addEventListener('click', function (e) {
      var hs = e.target.closest('[data-bpv-hotspot]');
      if (!hs || !root.contains(hs)) return;
      e.preventDefault();
      stopAuto();
      goToStep(hs.dataset.bpvHotspot, true);   // tampoco gira: se queda en el ángulo actual
    });

    /* Drag horizontal = girar el morral (frontal <-> espalda, o la vuelta de 360°) */
    if (stageCol && !scrollSpin && !girarSiempre && (tabs.length > 1 || root.querySelector('[data-bpv-frames]'))) {
      var dragging = false, startX = 0, startY = 0, fired = false;
      var axis = null;        // en celular: 'x' gira, 'y' deja pasar el scroll
      var startFrame = 0;

      function dragStart(x, y) {
        if (is3D()) return;   // model-viewer ya gestiona el giro
        dragging = true; startX = x; startY = y; fired = false; axis = null;
        if (is360()) { stopIntro(); hydrateFrames(colorway); startFrame = frameAt[colorway]; }
      }
      function dragMove(x, y) {
        if (!dragging) return false;
        var delta = x - startX;

        if (axis === null) {
          var dy = Math.abs(y - startY), dx = Math.abs(delta);
          if (dx < 6 && dy < 6) return false;
          axis = dx > dy ? 'x' : 'y';
          if (axis === 'y') { dragging = false; return false; }
        }

        if (is360()) {
          // Una vuelta completa por cada ancho de la columna arrastrado
          var total = frameCount(colorway);
          var span = stageCol.getBoundingClientRect().width || 400;
          var steps = Math.round(delta * turns / (span / total));
          if (!steps) return true;
          stopAuto(); stopIntro();
          setFrame(colorway, invert ? startFrame + steps : startFrame - steps);
          return true;
        }

        if (fired || Math.abs(delta) < 45) return true;
        fired = true;
        stopAuto();
        setView(view === 'front' ? 'back' : 'front');
        return true;
      }
      function dragEnd() { dragging = false; axis = null; }

      stageCol.addEventListener('mousedown', function (e) {
        if (e.target.closest('[data-bpv-hotspot], [data-bpv-tab], [data-bpv-swatch], [data-bpv-hotspot-toggle]')) return;
        if (is3D()) return;
        e.preventDefault();
        dragStart(e.clientX, e.clientY);
        axis = 'x';   // con mouse no hay scroll que proteger
      });
      document.addEventListener('mousemove', function (e) { dragMove(e.clientX, e.clientY); });
      document.addEventListener('mouseup', dragEnd);

      stageCol.addEventListener('touchstart', function (e) {
        if (e.target.closest('[data-bpv-hotspot], [data-bpv-tab], [data-bpv-swatch], [data-bpv-hotspot-toggle]')) return;
        dragStart(e.touches[0].clientX, e.touches[0].clientY);
      }, { passive: true });
      stageCol.addEventListener('touchmove', function (e) {
        if (!dragging) return;
        var moved = dragMove(e.touches[0].clientX, e.touches[0].clientY);
        // Girando: la página no se mueve debajo del dedo
        if (moved && axis === 'x' && e.cancelable) e.preventDefault();
      }, { passive: false });
      stageCol.addEventListener('touchend', dragEnd);
      stageCol.addEventListener('touchcancel', dragEnd);
    }

    /* ---- vuelta de presentación ----
       Al aparecer la sección el morral da una vuelta sola y se queda quieto.
       Cualquier gesto del visitante la corta. */
    var introTimer = null, introDone = false;

    function stopIntro() {
      if (introTimer) { clearInterval(introTimer); introTimer = null; }
      introDone = true;
    }

    function runIntro() {
      if (scrollSpin || girarSiempre) return;   // esos modos manejan el giro ellos mismos
      if (!introOn || introDone || introTimer || !is360() || is3D()) return;
      introDone = true;
      var total = frameCount(colorway);
      var started = false;

      function spin() {
        if (started || introTimer) return;
        started = true;
        var left = total;
        introTimer = setInterval(function () {
          if (left-- <= 0) { clearInterval(introTimer); introTimer = null; return; }
          setFrame(colorway, frameAt[colorway] + (invert ? -1 : 1));
        }, introMs);
      }

      hydrateFrames(colorway, spin);
      // Si alguna foto se demora o falla, la vuelta arranca igual
      setTimeout(spin, 2500);
    }

    ['mousedown', 'touchstart'].forEach(function (ev) {
      root.addEventListener(ev, stopIntro, { passive: true });
    });

    /* ---- giro por scroll ----
       En la portada el morral no se arrastra: gira un poco solo, siguiendo el
       desplazamiento de la página, y vuelve al frente si se sube. */
    if (scrollSpin) {
      var pedido = false;
      /* Se sigue la caja de la foto, no la sección entera, y la vuelta se
         completa cuando lleva recorrido el 60% de su alto: si se reparte por
         todo el tramo, el morral ya salió de pantalla antes de girar y el
         movimiento no se percibe. */
      var seguido = stageCol || root;

      function pintarPorScroll() {
        pedido = false;
        if (!is360()) return;
        var r = seguido.getBoundingClientRect();
        if (!r.height) return;
        var y = window.pageYOffset || document.documentElement.scrollTop || 0;
        /* El giro cubre TODO el tramo en que el morral se ve: arranca cuando
           ya está bien a la vista (si está arriba de todo, desde el primer
           píxel de scroll) y termina recién cuando está por salir por arriba.
           Si se completa antes, se lo ve frenar en seco todavía en pantalla. */
        var docTop = r.top + y;
        var arranque = docTop - window.innerHeight * 0.55;
        if (arranque < 0) arranque = 0;
        var fin = docTop + r.height * 0.9;
        var recorrido = fin - arranque;
        if (recorrido < 1) recorrido = 1;
        var p = (y - arranque) / recorrido;
        if (p < 0) p = 0;
        if (p > 1) p = 1;
        var n = Math.round(p * scrollSpin);
        if (n !== frameAt[colorway]) setFrame(colorway, invert ? -n : n);
      }

      function alScrollear() {
        if (pedido) return;
        pedido = true;
        requestAnimationFrame(pintarPorScroll);
      }

      window.addEventListener('scroll', alScrollear, { passive: true });
      window.addEventListener('resize', alScrollear, { passive: true });
      hydrateFrames(colorway, pintarPorScroll);
    }

    /* ---- giro continuo ----
       El morral de la portada gira solo, sin parar. Se detiene únicamente
       cuando sale de pantalla (no gastar batería girando algo que nadie ve) y
       respeta a quien pidió menos animación en su sistema. */
    if (girarSiempre) {
      /* Sin guarda de «reducir animaciones»: el pedido es que gire siempre, y
         una guarda que se dispara sola deja el morral quieto sin explicación. */
      var rafGiro = null, ultimoTs = 0, sobrante = 0, enPantalla = false;

      function pedirGiro() {
        if (rafGiro || !enPantalla) return;
        rafGiro = requestAnimationFrame(pasoGiro);
      }

      function pasoGiro(ts) {
        rafGiro = null;
        if (!enPantalla) return;
        if (!ultimoTs) ultimoTs = ts;
        sobrante += ts - ultimoTs;
        ultimoTs = ts;
        if (sobrante >= girarSiempre) {
          var saltos = Math.floor(sobrante / girarSiempre);
          sobrante -= saltos * girarSiempre;
          // Si la pestaña estuvo dormida, no descargar la espera de golpe
          if (saltos > 4) saltos = 4;
          setFrame(colorway, frameAt[colorway] + (invert ? -saltos : saltos));
        }
        pedirGiro();
      }

      function arrancarGiro() {
        if (enPantalla || !is360()) return;
        enPantalla = true; ultimoTs = 0; sobrante = 0;
        hydrateFrames(colorway, pedirGiro);
        pedirGiro();
      }

      function frenarGiro() {
        enPantalla = false; ultimoTs = 0;
        if (rafGiro) { cancelAnimationFrame(rafGiro); rafGiro = null; }
      }

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) arrancarGiro(); else frenarGiro();
          });
        }, { threshold: 0.05 }).observe(stageCol || root);
      } else {
        arrancarGiro();
      }
    }

    /* Pausa el auto-ciclo mientras el cursor está encima */
    root.addEventListener('mouseenter', stopAuto);

    /* El visor 3D se carga cuando la sección se acerca a la pantalla */
    if (root.querySelector('[data-bpv-model]')) {
      if ('IntersectionObserver' in window) {
        var mvObs = new IntersectionObserver(function (entries, obs) {
          if (entries.some(function (e) { return e.isIntersecting; })) { loadModelViewer(); obs.disconnect(); }
        }, { rootMargin: '400px' });
        mvObs.observe(root);
      } else {
        loadModelViewer();
      }
    }

    /* El primer contacto con el visor dispara la descarga de la secuencia */
    if (stageCol) {
      ['mouseenter', 'touchstart', 'pointerdown'].forEach(function (ev) {
        stageCol.addEventListener(ev, function () { hydrateFrames(colorway); }, { passive: true, once: false });
      });
    }

    /* La secuencia se descarga y da su vuelta cuando la sección llega a pantalla */
    if (root.querySelector('[data-bpv-frames]')) {
      if ('IntersectionObserver' in window) {
        var seqObs = new IntersectionObserver(function (entries, obs) {
          if (!entries.some(function (e) { return e.isIntersecting; })) return;
          obs.disconnect();
          if (introOn) runIntro(); else hydrateFrames(colorway);
          sharpenSoon();
        }, { threshold: 0.3 });
        seqObs.observe(root);
      } else {
        hydrateFrames(colorway);
        sharpenSoon();
      }
    }

    /* Sólo auto-cicla cuando la sección está a la vista */
    if (autoplay && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) startAuto(); else stopAuto();
        });
      }, { threshold: 0.35 }).observe(root);
    } else {
      startAuto();
    }

    /* Lo usa el editor de temas para saltar al detalle seleccionado */
    root.__bpvGoToStep = function (key) { stopIntro(); stopAuto(); goToStep(key); };

    /* ---- ayuda del editor: mover el punto arrastrándolo ----
       El editor de temas no deja que la vista previa guarde ajustes, así que
       esto no guarda nada: se arrastra el punto y se muestran los dos números
       para copiarlos en «Dónde va el punto». Solo corre dentro del editor. */
    if (window.Shopify && window.Shopify.designMode) {
      document.documentElement.classList.add('bpv-edit');
      var lector = document.querySelector('.bpv__coords');
      if (!lector) {
        lector = document.createElement('div');
        lector.className = 'bpv__coords';
        document.body.appendChild(lector);
      }

      root.addEventListener('pointerdown', function (e) {
        var hs = e.target.closest && e.target.closest('[data-bpv-hotspot]');
        if (!hs || !root.contains(hs)) return;
        var caja = hs.closest('[data-bpv-shot]') || hs.closest('[data-bpv-stage]');
        if (!caja) return;
        e.preventDefault();

        function mover(ev) {
          var b = caja.getBoundingClientRect();
          if (!b.width || !b.height) return;
          var x = Math.round(((ev.clientX - b.left) / b.width) * 100);
          var y = Math.round(((ev.clientY - b.top) / b.height) * 100);
          x = Math.max(0, Math.min(100, x));
          y = Math.max(0, Math.min(100, y));
          hs.style.left = x + '%';
          hs.style.top = y + '%';
          // Se reancla al cuadro que está a la vista para que el seguimiento cuadre
          if (hs.dataset.bpvHx !== undefined) {
            hs.dataset.bpvHx = x; hs.dataset.bpvHy = y;
            hs.dataset.bpvAnchor = frameAt[colorway];
            hs.classList.remove('is-hidden');
          }
          var r = hs.getBoundingClientRect();
          // Los tres números que hay que copiar, en el mismo orden del editor
          lector.textContent = 'cuadro ' + frameAt[colorway] + '   ·   ' + x + '  /  ' + y;
          lector.style.left = (r.left + r.width / 2) + 'px';
          lector.style.top = (r.top - 8) + 'px';
          lector.classList.add('is-on');
        }
        function soltar() {
          document.removeEventListener('pointermove', mover);
          document.removeEventListener('pointerup', soltar);
        }
        document.addEventListener('pointermove', mover);
        document.addEventListener('pointerup', soltar);
        mover(e);
      });
    }

    /* En celular el texto del detalle va DEBAJO de la foto: se mide su alto y se
       publica en --bpv-pie-h para que la foto termine justo donde él empieza. */
    function medirPie() {
      var lista = root.querySelector('.bpv__steps');
      if (!lista || !root.classList.contains('bpv--pdp')) return;
      var chico = window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
      if (!chico) { lista.style.removeProperty('--bpv-pie-h'); return; }
      var pie = root.querySelector('.bpv__step.is-active > .bpv__step-copy');
      lista.style.setProperty('--bpv-pie-h', (pie ? Math.ceil(pie.getBoundingClientRect().height) : 0) + 'px');
    }
    var pieOriginal = paintStep;
    paintStep = function (key) { pieOriginal(key); medirPie(); };
    window.addEventListener('resize', medirPie, { passive: true });
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(medirPie);
      var listaEl = root.querySelector('.bpv__steps');
      if (listaEl) ro.observe(listaEl);
    }
    setTimeout(medirPie, 60);
    setTimeout(medirPie, 400);

    /* ---- estado inicial ---- */
    paintColorway();
    paintView();
    paintStep(activeKey);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-bpv]').forEach(init);
  }

  /* En el editor de temas: al seleccionar un detalle, el morral gira hasta su
     ángulo y su punto queda encendido. Sin esto no se ve qué se está moviendo
     con los controles de posición. */
  document.addEventListener('shopify:block:select', function (e) {
    var step = e.target && e.target.closest ? e.target.closest('[data-bpv-step]') : null;
    if (!step) return;
    var root = step.closest('[data-bpv]');
    if (root && root.__bpvGoToStep) root.__bpvGoToStep(step.dataset.bpvStep);
  });

  /* Interruptor de los puntos para el visitante: cambia la misma clase que usa
     el ajuste del tema, así el estilo es uno solo.
     ⚠️ El tema mete este archivo DOS veces (una por sección), así que sin la
     bandera el listener queda duplicado, el clic se procesa dos veces y el
     estado vuelve al mismo lugar: parecía que el botón no hacía nada. */
  if (!window.__bpvToggleBound) {
    window.__bpvToggleBound = true;
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-bpv-hotspot-toggle]') : null;
      if (!btn) return;
      var root = btn.closest('[data-bpv]');
      if (!root) return;
      var encender = btn.getAttribute('aria-pressed') !== 'true';
      btn.setAttribute('aria-pressed', encender ? 'true' : 'false');
      root.classList.toggle('bpv--sin-puntos', !encender);
    });
  }

  /* Las fotos de los detalles abren el mismo modal que un producto normal.
     No se copia el visor: se le pasan los datos a la función del tema
     (window.theme.LoadPhotoswipe), la misma que usa zoom.js en el PDP.
     Una foto por detalle — la del colorway activo — para poder pasar de un
     detalle al siguiente dentro del modal. */
  if (!window.__bpvZoomBound) {
    window.__bpvZoomBound = true;
    document.addEventListener('click', function (e) {
      var foto = e.target && e.target.closest ? e.target.closest('.bpv__step-photo[data-zoom-src]') : null;
      if (!foto) return;
      var root = foto.closest('[data-bpv]');
      if (!root || !window.theme || !window.theme.LoadPhotoswipe) return;

      var items = [], indice = 0;
      Array.prototype.forEach.call(root.querySelectorAll('[data-bpv-step]'), function (paso) {
        var f = paso.querySelector('.bpv__step-photo.is-active[data-zoom-src]') || paso.querySelector('.bpv__step-photo[data-zoom-src]');
        if (!f) return;
        if (f === foto) indice = items.length;
        items.push({
          src: f.getAttribute('data-zoom-src'),
          msrc: f.getAttribute('data-zoom-src'),
          w: parseInt(f.getAttribute('data-zoom-w'), 10),
          h: parseInt(f.getAttribute('data-zoom-h'), 10)
        });
      });
      if (!items.length) return;

      /* El detalle es un <button>: sin esto el clic también lo abre o lo cierra. */
      e.preventDefault();
      e.stopPropagation();

      new window.theme.LoadPhotoswipe(items, {
        barsSize: { top: 60, bottom: 60 },
        history: false,
        focus: false,
        index: indice,
        mainClass: items.length === 1 ? 'pswp-zoom-gallery pswp-zoom-gallery--single' : 'pswp-zoom-gallery',
        showHideOpacity: true,
        showAnimationDuration: 250,
        hideAnimationDuration: 250,
        closeOnScroll: false,
        closeOnVerticalDrag: false,
        captionEl: false,
        closeEl: true,
        closeElClasses: ['caption-close'],
        tapToClose: false,
        clickToCloseNonZoomable: false,
        maxSpreadZoom: 2,
        loop: true,
        spacing: 0,
        allowPanToNext: true,
        pinchToClose: false
      }, 0, foto);
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* Theme editor: re-inicializar al recargar la sección */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
